export default {
  getCallsMonitorOperadorDados: state => state.callsMonitorOperadorDados,
  getRamais: state => state.ramaisMonitor,

  getCallsOnWaitByQueue: state => idQueue => {
    return state.callsOnWait
    .filter(callOnWait => callOnWait.idQueue === idQueue)
    .sort((a, b) => {
      if (a.time < b.time) {
        return 1
      }
      if (a.time > b.time) {
          return -1
        }
        return 0
      })
    },

  getApiRamais: state => state.ramais,

  getCallsMonitorOperador: state => {
    return state.callsMonitorOperador
  },

  getOperadoresOnline: state => idQueue => {
    let operadoresOnline = 0

    state.ramaisMonitor.forEach(operador => {
      if (typeof operador.arrayQueues !== 'undefined') {
        if (operador.arrayQueues.findIndex(queue => queue.queue === idQueue) !== -1) {
          operadoresOnline += 1
        }
      }
    })

    return operadoresOnline
  },

  getOperadoresLivres: state => idQueue => {
    let operadoresFree = 0

    state.ramaisMonitor.forEach(operador => {
      if (typeof operador.arrayQueues !== 'undefined') {
        if (operador.arrayQueues.findIndex(queue => queue.queue === idQueue) !== -1) {
          if (
            (operador.paused === '0' && operador.channels.length === 0) ||
            (operador.paused === '0' && typeof operador.channels === 'undefined')
          ) {
            operadoresFree += 1
          }
        }
      }
    }) 

    return operadoresFree
  },

  getOperadoresOcupados: state => idQueue => {
    let operadoresBusy = 0

    state.ramaisMonitor.forEach(operador => {
      if (typeof operador.arrayQueues !== 'undefined') {
        if (operador.arrayQueues.findIndex(queue => queue.queue === idQueue) !== -1) {
          if (typeof operador.channels !== 'undefined' && operador.channels.length > 0) {
            operadoresBusy += 1
          }
        }
      }
    })
    return operadoresBusy
  },

  getOperadoresPausados: state => idQueue => {
    let operadoresPaused = 0

    state.ramaisMonitor.forEach(operador => {
      if (typeof operador.arrayQueues !== 'undefined') {
        if (operador.arrayQueues.findIndex(queue => queue.queue === idQueue) !== -1) {
          if (operador.paused === '1') {
            operadoresPaused += 1
          }
        }
      }
    })

    return operadoresPaused
  },
  getprotocoloChamadas: state => state.protocoloChamadas,
  getHistory: state => state.history,
  getEndListAgent: state => state.endListAgent,

}
